import React from "react";
import classes from "./UserPrompt.module.css";

const UserPrompt = ({ prompt }) => {
  return (
    <article className={classes.prompt}>
      <p>{prompt}</p>
    </article>
  );
};

export default UserPrompt;
